export default __webpack_public_path__ + "static/media/guide_bg_top.f1b1e1f1.png";